import { AccordionIcon } from "./incidentForm.style";
import React from "react";

interface IProps {
  sectionKey: string;
  handleCollapse: any;
  isOpen: boolean;
  toggleComponent?: React.ReactNode;
}

const SectionHeader = ({ sectionKey, handleCollapse, isOpen, toggleComponent }: IProps) => {
  return (
      <div 
      className="mt-7 flex w-min cursor-pointer"
        onClick={() => handleCollapse(sectionKey)}
      >
        <AccordionIcon
          src="../../../assets/images/circle.png"
          isOpen={isOpen}
          alt=""
        />
        <span className="mb-5 ml-3 whitespace-nowrap text-2xl">{sectionKey}</span>
        
        {/* Render toggle component right after the section title */}
        {toggleComponent && (
          <div className="ml-3 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
            {toggleComponent}
          </div>
        )}
      </div>  
  );
};

export default SectionHeader;
